import { render, staticRenderFns } from "./admin-job-positions.vue?vue&type=template&id=22d6f669&scoped=true"
import script from "./admin-job-positions.vue?vue&type=script&lang=js"
export * from "./admin-job-positions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6f669",
  null
  
)

export default component.exports